import React from 'react';
import Box from '@mui/material/Box';
import LandingNav from './LandingNav';
import LandingFooter from './LandingFooter';
import noiseTexture from 'src/assets/images/landing/noise-texture.png';

interface LandingLayoutProps {
  children: React.ReactNode;
  hideFooter?: boolean;
  hideNav?: boolean;
}

export default function LandingLayout({
  children,
  hideFooter = false,
  hideNav = false,
}: LandingLayoutProps) {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', position: 'relative' }}>
      {/* Noise texture overlay */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundImage: `url(${noiseTexture})`,
          backgroundRepeat: 'repeat',
          backgroundSize: '300px',
          opacity: 0.4,
          pointerEvents: 'none',
          zIndex: 9999,
        }}
      />
      {!hideNav && <LandingNav />}
      <Box component="main" sx={{ flex: 1 }}>
        {children}
      </Box>
      {!hideFooter && <LandingFooter />}
    </Box>
  );
}
